"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var FlexElement = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\t", "\n"])), function (props) {
  var direction = props.direction,
      wrap = props.wrap,
      justifyContent = props.justifyContent,
      alignItems = props.alignItems,
      alignContent = props.alignContent,
      onClick = props.onClick;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tflex-direction: ", ";\n\t\t\tflex-wrap: ", ";\n\t\t\tjustify-content: ", ";\n\t\t\talign-items: ", ";\n\t\t\tcursor: ", ";\n\t\t\t", ";\n\t\t"])), direction, wrap, justifyContent, alignItems, !!onClick ? "pointer" : "inherit", alignContent && alignContent);
});
var OuterDiv = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var gutter = props.gutter;
  return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tpadding: ", "px;\n\t\t"])), gutter);
});

var Flex = function Flex(_ref) {
  var children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "row" : _ref$direction,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? "nowrap" : _ref$wrap,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "flex-start" : _ref$justifyContent,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "stretch" : _ref$alignItems,
      _ref$alignContent = _ref.alignContent,
      alignContent = _ref$alignContent === void 0 ? null : _ref$alignContent,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick,
      itemRef = _ref.itemRef,
      dataTestId = _ref.dataTestId;
  var elements = react_1.default.Children.map(children, function (child) {
    if (gutter > 0) {
      return (0, jsx_runtime_1.jsx)(OuterDiv, {
        gutter: gutter,
        children: child
      });
    } else {
      return child;
    }
  });
  return (0, jsx_runtime_1.jsx)(FlexElement, {
    direction: direction,
    wrap: wrap,
    justifyContent: justifyContent,
    alignItems: alignItems,
    alignContent: alignContent,
    ref: itemRef,
    onClick: onClick,
    className: className,
    css: style,
    "data-testid": dataTestId,
    children: elements
  });
};

exports.Flex = Flex;